import React from 'react';
import { MagnifyingGlassIcon, BellIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';

const AdminHeader = ({ user }) => {
    return (
        <header className="bg-white h-20 px-8 flex items-center justify-between border-b border-gray-100">
            {/* Welcome Message */}
            <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5 }}
            >
                <h1 className="text-2xl font-bold text-[#333333]">Welcome back, {user?.name?.split(' ')[0] || 'Admin'}</h1>
                <p className="text-sm text-gray-500 mt-1">Manage your health community and content!</p>
            </motion.div>

            {/* Right Side Actions */}
            <div className="flex items-center space-x-6">
                {/* Search Bar */}
                <div className="relative hidden md:block">
                    <MagnifyingGlassIcon className="h-5 w-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
                    <input
                        type="text"
                        placeholder="Search"
                        className="pl-10 pr-4 py-2 bg-gray-50 border-none rounded-full text-sm text-gray-600 focus:ring-2 focus:ring-gray-200 w-64 transition-all"
                    />
                </div>

                {/* Notifications */}
                <button className="relative p-2 text-gray-500 hover:bg-gray-50 rounded-full transition-colors">
                    <BellIcon className="h-6 w-6" />
                    <span className="absolute top-2 right-2 h-2 w-2 bg-red-500 rounded-full border-2 border-white"></span>
                </button>

            </div>
        </header>
    );
};

export default AdminHeader;
